import React, { useState, useEffect } from "react";
import {
  CalendarDropDownIcon,
  closeIcon,
} from "../../../utils/icons";
import PropTypes from "prop-types";
import {
  DateRangePickerContainer,
  HeaderContainer,
  StyledBody,
} from "../../Manager/Dashboard/style";
import { Modal } from "react-bootstrap";
import {
  Container,
  CalendarHeader,
  Grid,
  Day,
  BottomButtons,
  DownloadButton,
  DayWrap,
  StyledModal,
} from "./style";
import dayjs from "dayjs";
import { ManagerIconContainer } from "../../Manager/styles";
import ReusableDropdown from "../Dropdowns/registrationDropdown";
import { generateMonthOptions, generateYearOptions } from "../../../utils/methods";
import { t } from "i18next";

const getDaysInMonth = (year, month) => {
  const date = dayjs(new Date(year, month, 1));
  const days = [];
  let current = date;
  while (current.month() === month) {
    days.push(current);
    current = current.add(1, "day");
  }
  return days;
};

const CustomDatePicker = ({ showModal, onClose, date, /*stateDateSelected,*/ changeDate, type, color }) => {
  const today = dayjs().startOf("day");
  const [currentMonth, setCurrentMonth] = useState(today.month());
  const [currentYear, setCurrentYear] = useState(dayjs().subtract(18, "year").year());
  const [startDate, setStartDate] = useState(date);
  const days = getDaysInMonth(currentYear, currentMonth);

  useEffect(() => {
    if (date) {
      setCurrentMonth(dayjs(date).month());
      setCurrentYear(dayjs(date).year());
      setStartDate(date);
    }
  }, [date, showModal]);

  //   const handleMonthChange = (direction) => {
  //     const newDate = dayjs(new Date(currentYear, currentMonth)).add(direction, "month");
  //     // const isBeforeToday = newDate.isBefore(today, "month");
  //     // if (isBeforeToday) return;
  //     setCurrentMonth(newDate.month());
  //     setCurrentYear(newDate.year());
  //   };

  const submitDate = () => {
    changeDate(startDate, type);
  };

  const handleDayClick = (day) => {
    window.console.log("day",day)
    // const baseDate =
    //   type !== "date"
    //     ? stateDateSelected
    //       ? dayjs(stateDateSelected).startOf("day")
    //       : today
    //     : today;

    // if (day.isBefore(baseDate, "day")) return;
    setStartDate(day);
  };

  const isSameDay = (d1, d2) => d1 && d2 && d1.isSame(d2, "day");

  const handleSelect = (selectedYear) => {
    setCurrentYear(Number(selectedYear));
  };

  return (
    <StyledModal id="download-popup" show={showModal} onHide={onClose} width={"auto"} right="0%" top='15%' height={"auto"}>
      <Modal.Header>
        <HeaderContainer id="download-heading">
          <div className="report-title">
            <span className="header-text">{t("Select Date")}</span>
          </div>
          <ManagerIconContainer style={{ cursor: "pointer", marginBottom: "16px" }} onClick={onClose}>
            {closeIcon(color ? color :"#F37A65", 14, 14)}
          </ManagerIconContainer>
        </HeaderContainer>
      </Modal.Header>
      <StyledBody id="calendar-container" style={{ borderRadius: "0 0 6px 6px", width:"100%" }}>
        <DateRangePickerContainer id="date-range-picker">
          <Container id="date-container" className="date-time" isDateTimePicker>
            <div id="calendar-container" className="date-container" style={{ width:"100%" }}>
              <CalendarHeader id="calendar-header" style={{justifyContent:'start'}}>
                {/* <Button id="prev-button" onClick={() => handleMonthChange(-1)}>
                  {CalendarPrevArrow()}
                </Button>

                <span id="month-name" className="title">
                  {dayjs(new Date(currentYear, currentMonth)).format("MMMM")}
                </span>
                <Button id="next-prev" onClick={() => handleMonthChange(1)}>
                  {CalendarNextArrow()}
                </Button> */}

                {/* <select
                  value={currentYear}
                  onChange={(e) => setCurrentYear(Number(e.target.value))}
                  style={{
                    marginLeft: "12px",
                    padding: "4px 8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                >
                  {Array.from({ length: 100 }, (_, i) => dayjs().year() - 18 - i).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select> */}
                <ReusableDropdown
                  selectedValue={dayjs().month(currentMonth).format("MMMM")}
                  onSelect={(selected) => {
                    const selectedIndex = generateMonthOptions({ useIndexValue: false, asObject: false }).indexOf(selected);
                    setCurrentMonth(selectedIndex);
                  }}
                  options={generateMonthOptions({ asObject: false, useIndexValue: false })}
                  bgColor={'#F37A65'}
                  getIcon={() => CalendarDropDownIcon( color ? color :'#F37A65', '270')}
                  margin={'0px 16px 0px 12px'}
                  isRight={'-52%'}
                />
                <ReusableDropdown
                  selectedValue={currentYear.toString()}
                  onSelect={handleSelect}
                  options={generateYearOptions({ asObject: false })}
                  //   labelKey={labelKey}
                  //   valueKey={valueKey}
                  bgColor={'#F37A65'}
                  getIcon={() => CalendarDropDownIcon( color ? color : '#F37A65','270')}
                  isRight={'-50%'}
                />
              </CalendarHeader>

              <Grid id="grid-days">
                {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
                  <div className="day-name" key={day}>
                    {t(day)}
                  </div>
                ))}
              </Grid>

              <DayWrap>
                {Array.from({ length: (days[0].day() + 6) % 7 }).map((_, idx) => (
                  <Day style={{ background: "transparent" }} key={`empty-${idx}`} disabled />
                ))}
                {days.map((day) => {
                  const eighteenYearsAgo = dayjs().subtract(18, 'year').endOf("day");

                  const isDisabled = day.isAfter(eighteenYearsAgo);
                  return (
                    <Day
                      id="days"
                      key={day.toString()}
                      onClick={() => !isDisabled && handleDayClick(day)}
                      isSelected={isSameDay(day, startDate)}
                      disabled={isDisabled}
                    >
                      {day.date()}
                    </Day>
                  );
                })}
              </DayWrap>
            </div>
          </Container>

          <div style={{ width: "100%", height: "1px", background: "#EFEFEF", margin: "0 0 16px 0" }}></div>

          <BottomButtons id="bottom-buttons">
            <DownloadButton  color={color}  id="download-buttons" disabled={!startDate} onClick={() => submitDate()} style={{minWidth:'200px',minHeight:'48px'}}>
              {t('Done')}
            </DownloadButton>
          </BottomButtons>
        </DateRangePickerContainer>
      </StyledBody>
    </StyledModal>
  );
};

CustomDatePicker.propTypes = {
  onClose: PropTypes.func,
  color: PropTypes.string,
  showModal: PropTypes.bool,
  date: PropTypes.object,
  stateDateSelected: PropTypes.object,
  type: PropTypes.string,
  changeDate: PropTypes.func,
};

export default CustomDatePicker;
